import { SVGProps } from 'react';
import { ReactComponent } from 'icons/icon-sort.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const SortIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-sort" {...props} />;
};
